export interface ErrorMessage {
  code: string
  message: string
}

export const errorMessages: ErrorMessage[] = [
  {
    code: 'EB0001',
    message: '企業IDを入力してください。',
  },
  {
    code: 'EB0002',
    message: '内部エラーが発生しました。',
  },
  {
    code: 'EB0010',
    message: '入力した自社商品コードは既に登録されています。',
  },
  {
    code: 'EB0015',
    message: '指定されたフォルダの権限がないため、操作できません。',
  },
  {
    code: 'EB0016',
    message: '利用者情報にて法人番号を登録してください。',
  },
  {
    code: 'EF0001',
    message: '入力してください',
  },
  {
    code: 'EF0003',
    message: '1件以上、登録してください。',
  },
  {
    code: 'EF0010',
    message: '半角英数字・記号で入力してください。',
  },
  {
    code: 'EF0011',
    message: '半角英数字で入力してください。',
  },
  {
    code: 'EF0012',
    message: '半角英字で入力してください。',
  },
  {
    code: 'EF0017',
    message: '入力された法人番号は存在しません。',
  },
  {
    code: 'EF0018',
    message: '法人番号は13桁で指定してください',
  },
  {
    code: 'EF0021',
    message: '{0}文字以内で入力してください。',
  },
  {
    code: 'EF0033',
    message: '{0}をご確認の上、再度{1}をおこなってください。',
  },
  {
    code: 'EF9901',
    message: '登録に失敗しました。時間をおいてから、再度操作してください。',
  },
  {
    code: 'EF9904',
    message: '取得に失敗しました。時間をおいてから、再度操作してください。',
  },
  {
    code: 'EF018002',
    message: '入力した自社商品コードは既に登録されています。',
  },
  {
    code: 'EF019001',
    message: '入力した自社商品コードは既に登録されています。',
  },
  {
    code: 'IF0001',
    message: '正常に更新されました。',
  },
  {
    code: 'EF011002',
    message: '送信先を選択してください。',
  },
  {
    code: 'EF011003',
    message: '送信するドキュメントを追加してください。',
  },
  {
    code: 'EF012001',
    message: '送信先担当者のメールアドレスは、入力された法人番号と異なる法人番号の企業でご利用されています。',
  },
]
